export default __webpack_public_path__ + "static/media/desert.c90f5cbe.jpg";